<template>
  <div class="reelbuzz">
    <div class="header">
        <div class="header-menu">
            <div class="header-left">
                <img src="../assets/logo.png" alt="logo-icon">
                <p>Crédito Sin Fronteras, S.A.P.I. de C.V., SOFOM, E.N.R..</p>
            </div>
            <ul class="header-right">
              <li v-for="section in sections" :key="section.id" class="menu">
                <a :href="'#' + section.id" @click="gotoMEnu(section.id)" :class="{ 'active': section.id === currentSection }">{{ section.title }}</a>
              </li>
            </ul>
        </div>
    </div>
    <div class="reelbuzz-content" >
      <div class="reelbuzz-box" id="section1">
        <div class="header-box" >
          <p class="name">Política de privacid</p>
          <!-- <p class="name">achieve success.</p> -->
        </div>
      </div>
    </div>

<div class="policy-box">

  <h1 class="policy-title">Política de Privacidad</h1>

  <p class="policy-intro">
    CashMore (desarrollador Cashmore, S.A. de C.V., sitio web: <a href="https://cashmoretech.com/" target="_blank">https://cashmoretech.com/</a>) siempre considera la protección de la privacidad del usuario como un principio central. Nos dedicamos a construir un entorno de servicio confiable y seguro, garantizando que su información personal sea gestionada y protegida de manera estricta.
  </p>
  <p class="policy-intro">
    CRÉDITO SIN FRONTERAS, S.A.P.I. de C.V., SOFOM, E.N.R. (sitio web: <a href="https://creditosinfronteras.com/" target="_blank">https://creditosinfronteras.com/</a>), como una Sociedad Financiera de Objeto Múltiple autorizada y regulada por las autoridades mexicanas, ha establecido una asociación estratégica con Cashmore, S.A. de C.V. para desarrollar y operar conjuntamente la aplicación de crédito en línea "CashMore". Bajo este modelo de colaboración, Cashmore, S.A. de C.V. es responsable del desarrollo tecnológico de la plataforma, la promoción en el mercado y la adquisición de usuarios; mientras que CRÉDITO SIN FRONTERAS, S.A.P.I. de C.V., SOFOM, E.N.R. es responsable de proporcionar los fondos de crédito legales y conformes, y asume la decisión crediticia final.
  </p>
  <p class="policy-intro">
    Con base en la colaboración antes mencionada, para completar el proceso de evaluación de elegibilidad para el préstamo y el servicio de crédito, podemos compartir información personal relevante con CRÉDITO SIN FRONTERAS, S.A.P.I. de C.V., SOFOM, E.N.R. cuando sea necesario. Sin embargo, sin su decisión independiente y permiso explícito, nunca proporcionaremos o divulgaremos su información a ningún otro tercero. Esta política puede actualizarse oportunamente debido al desarrollo de los servicios. Su uso continuado de los servicios constituye la comprensión plena, revisión, confirmación y aceptación de todo su contenido.
  </p>

  <!-- I -->
  <h2 class="policy-section-title">I. Información Recopilada</h2>

  <h3 class="policy-sub-title">Información de Identificación Personal</h3>
  <p>Para verificar con precisión su identidad y proteger la seguridad de su cuenta, recopilamos solo la siguiente información dentro del ámbito necesario: su nombre, número de teléfono móvil, número de identificación, información de tarjeta bancaria, dirección de correo electrónico y dirección domiciliaria. Esta información estará estrictamente protegida y se utilizará únicamente para los fines declarados.</p>

  <h3 class="policy-sub-title">Información del Dispositivo</h3>
  <p>Para garantizar el funcionamiento estable de las funciones centrales de la aplicación y proporcionar un mejor servicio y soporte, podemos obtener información sobre el dispositivo que utiliza, incluidos IDFV, IDFA, modelo de hardware, versión del sistema operativo y otra información relevante. Esta información se utilizará para garantizar la seguridad y legalidad del uso del producto por parte del usuario.</p>

  <h3 class="policy-sub-title">Información de la Lista de Contactos</h3>
  <p>Cuando utiliza CashMore para solicitar un préstamo, para prevenir fraudes y verificar su identidad, necesitamos obtener selectivamente el nombre, número de teléfono e información de la relación de sus contactos de emergencia (no solicitamos permiso para acceder a su libreta de contactos). Mientras podamos contactarle a usted directamente en condiciones normales, no nos pondremos en contacto con los contactos de emergencia que haya proporcionado. Esta información se transmitirá cifrada al centro de seguridad: <a href="https://aplika.bajoprestopm.com/" target="_blank">https://aplika.bajoprestopm.com/</a>, garantizando su seguridad.</p>

  <h3 class="policy-sub-title">Información Financiera</h3>
  <p>Para evaluar con mayor precisión su situación crediticia y ofrecerle opciones de préstamo adecuadas, necesitamos que proporcione información financiera relevante (como estados de cuenta de transacciones, situación de deudas existentes), con el fin de realizar una evaluación del riesgo crediticio.</p>

  <h3 class="policy-sub-title">Información de Imágenes</h3>
  <p>Durante su proceso de verificación de identidad, solo procesaremos imágenes específicas que usted seleccione y cargue activamente (por ejemplo, comprobantes financieros, capturas de pantalla), utilizadas para la verificación de identidad y la prevención de fraudes. Esta operación no solicita ni obtiene permiso de acceso al álbum de fotos de su dispositivo; usted solo carga las fotos especificadas. Todos los datos de imagen se transmitirán cifrados a través de una conexión segura a nuestros servidores y se utilizarán estrictamente para los fines de seguridad declarados.</p>

  <h3 class="policy-sub-title">Información de la Cámara</h3>
  <p>Cuando utiliza funciones de préstamo que requieren reconocimiento facial, para completar la verificación de identidad y la detección de vivencia, necesitamos su autorización explícita para activar el permiso de la cámara y realizar la identificación biométrica. Esta operación se utiliza únicamente para verificar en tiempo real la autenticidad de su identidad; los datos relevantes se eliminarán de forma segura una vez completada la verificación.</p>

  <h3 class="policy-sub-title">Datos de Reconocimiento Facial</h3>
  <p>Para implementar los requisitos de gestión de identificación real del cliente, necesitamos recopilar su información facial para verificar la autenticidad de su identidad. Esta operación requiere su autorización explícita. Esta información se cifrará y subirá al centro de seguridad: <a href="https://aplika.bajoprestopm.com/" target="_blank">https://aplika.bajoprestopm.com/</a>. Sus datos faciales se usan solo para este propósito de verificación; la plataforma se compromete a no utilizarlos para otros fines ni compartirlos con terceros. Si no inicia una solicitud de préstamo dentro de las 72 horas posteriores a enviar la información, los datos relevantes serán eliminados automáticamente por el sistema. También puede eliminar activamente su información personal en cualquier momento dentro de la aplicación.</p>

  <h3 class="policy-sub-title">IDFA (Identificador para Anunciantes)</h3>
  <p>Con su permiso explícito, los datos relevantes se utilizan solo para los siguientes propósitos específicos: proporcionarle publicidad personalizada y evaluar su efectividad. Garantizamos no retener este tipo de datos a largo plazo; se eliminarán de forma segura después de su uso.</p>

  <h3 class="policy-sub-title">Información de Cuentas de Redes Sociales</h3>
  <p>Cuando solicita productos de crédito de terceros, para ayudar a completar los procesos necesarios y optimizar el modelo de gestión de riesgos, luego de su autorización explícita, procesaremos la información básica de sus cuentas de redes sociales relevantes (como apodo público, avatar). Esta información se cifrará y subirá al centro de seguridad y se utilizará estrictamente para mejorar la seguridad y conformidad del servicio, no para análisis no relacionados o interacción social.</p>

  <!-- II -->
  <h2 class="policy-section-title">II. Propósito de la Recopilación de Información</h2>
  <p>Recopilamos la información necesaria con el objetivo de proporcionarle servicios más precisos y seguros. Esta información se utiliza principalmente para:</p>
  <ul class="policy-list">
    <li>Establecer la cuenta central y verificar la identidad, asegurando que es usted quien realiza la operación.</li>
    <li>Completar procesos seguros de evaluación crediticia y transacciones, emparejándole con productos financieros adecuados.</li>
    <li>Responder oportunamente a sus consultas y necesidades, brindando soporte al cliente personalizado.</li>
    <li>Optimizar continuamente las funciones del producto y la calidad del servicio, mejorando su experiencia de uso.</li>
  </ul>
  <p>Todo el procesamiento de la información cumple estrictamente con las leyes y regulaciones relevantes y se realiza priorizando la protección de sus derechos.</p>

  <!-- III -->
  <h2 class="policy-section-title">III. Política de Compartir Datos</h2>
  <p>Nos comprometemos formalmente a que, en ningún caso, venderemos, distribuiremos o divulgaremos los datos personales de los usuarios a terceros no relacionados. Las situaciones específicas de intercambio son las siguientes:</p>

  <h3 class="policy-sub-title">Compartir Datos con el Socio Proveedor de Fondos</h3>
  <p>Para completar el proceso de aprobación de crédito y desembolso de fondos, compartimos la información necesaria del usuario con CRÉDITO SIN FRONTERAS, S.A.P.I. de C.V., SOFOM, E.N.R., incluyendo: nombre, información de identificación, información de contacto, situación financiera e información crediticia. Dichos datos se utilizan únicamente para evaluar la situación crediticia, aprobar la solicitud de préstamo y gestionar la cuenta. Todas las transferencias se realizan a través de canales cifrados.</p>

  <h3 class="policy-sub-title">Colaboración con Publicidad y Atribución</h3>
  <p>Compartimos datos técnicos relacionados con la identificación publicitaria con plataformas publicitarias certificadas (como AppsFlyer), incluyendo: IDFA, modelo de dispositivo e información de eventos de instalación. Dichos datos se utilizan únicamente para la atribución de efectividad publicitaria y no contienen información que permita la identificación personal.</p>

  <h3 class="policy-sub-title">Servicios SMS y Verificación</h3>
  <p>Para el registro de la cuenta, verificación de inicio de sesión y envío de notificaciones de servicio (como cambios en el estado de la cuenta, recordatorios de vencimiento), compartimos el número de teléfono móvil del usuario con los operadores de telecomunicaciones locales, exclusivamente para estos fines.</p>

  <h3 class="policy-sub-title">Colaboración en Recordatorios de Pagos Vencidos y Cobranza</h3>
  <p>Para los pagos vencidos no realizados, con el fin de llevar a cabo recordatorios y cobranza legales, compartiremos la información relevante dentro del ámbito necesario con socios de cobranza autorizados, incluyendo: nombre de usuario, número de teléfono móvil, número de pedido y días de mora. Todas las actividades de cobranza cumplen estrictamente con las leyes y regulaciones aplicables.</p>

  <p>Todos los datos están protegidos mediante canales cifrados durante su transmisión y almacenamiento, en cumplimiento de la <strong>Ley Federal de Protección de Datos Personales en Posesión de los Particulares (LFPDPPP)</strong>. CashMore siempre sigue los principios de "recopilación mínima, uso limitado, uso seguro" al procesar sus datos.</p>

  <!-- IV -->
  <h2 class="policy-section-title">IV. Cómo Garantizamos la Seguridad de los Datos</h2>
  <p>Protegemos la seguridad de sus datos mediante una doble garantía de tecnología de vanguardia y gestión estricta:</p>
  <ul class="policy-list">
    <li>Utilizamos tecnología de cifrado de alta resistencia a nivel bancario para la transmisión y almacenamiento de su información personal.</li>
    <li>Implementamos controles estrictos de permisos de acceso, limitando el contacto con los datos solo al personal autorizado para fines laborales específicos, con acuerdos de confidencialidad.</li>
    <li>El sistema monitorea en tiempo real todas las operaciones con datos, garantizando que cualquier actividad sea trazable.</li>
  </ul>

  <!-- V -->
  <h2 class="policy-section-title">V. Cambios en la Política de Privacidad</h2>
  <p>Para adaptarse al desarrollo empresarial y cumplir con los requisitos legales, podemos revisar oportunamente esta política de privacidad. Los contenidos modificados se basarán en el texto más reciente publicado en el sitio web oficial. Si ocurren ajustes significativos que involucren el alcance de la recopilación y uso de su información personal o los destinatarios del intercambio, le notificaremos a través de notificaciones push, mensajes dentro del sitio o correo electrónico.</p>
  <p>Si continúa utilizando nuestros servicios después de que la nueva política entre en vigencia, significa que ha revisado, comprendido y aceptado plenamente todos los términos revisados. Si no está de acuerdo con los cambios, tiene derecho a dejar de usar los servicios en cualquier momento y solicitar la cancelación de su cuenta.</p>

  <!-- VI -->
  <h2 class="policy-section-title">VI. Retención y Eliminación de Datos</h2>
  <p>Usted siempre tiene control completo sobre sus datos personales y puede decidir retenerlos o eliminarlos en cualquier momento.</p>
  <ol class="policy-list">
    <li><strong>Período de Retención:</strong> Conservamos los datos solo durante el período mínimo necesario para "completar el servicio" y "cumplir con las obligaciones legales"; una vez vencido el período o cumplido el propósito, se iniciará un procedimiento seguro para anonimizar o destruir completamente los datos.</li>
    <li><strong>Medidas de Seguridad:</strong> Todos los datos se almacenan en servidores cifrados de alto estándar y se respaldan regularmente; en caso de un incidente, la recuperación desde el respaldo se realizará solo dentro del alcance permitido por la ley.</li>
    <li><strong>Sincronización con Terceros:</strong> Los socios que procesan datos por encargo nuestro han firmado acuerdos legalmente vinculantes y deben cumplir con los mismos estándares de retención y eliminación.</li>
    <li>
      <strong>Cómo Eliminar Sus Datos:</strong>
      <ul class="policy-list policy-list--sub">
        <li><strong>Auto-servicio en la aplicación:</strong> Puede eliminar sus datos siguiendo las instrucciones dentro de la aplicación CashMore.</li>
        <li><strong>Correo electrónico:</strong> Envíe una solicitud a <a href="mailto:service@cashmoretech.com">service@cashmoretech.com</a> con el asunto "Solicitud de Eliminación de Datos". El servicio al cliente le guiará para completar la verificación de identidad antes de eliminar los datos.</li>
      </ul>
    </li>
    <li><strong>Aviso Importante:</strong> Una vez ejecutada la solicitud de eliminación, todos los datos asociados serán irrecuperables; si necesita utilizar los servicios nuevamente, deberá registrarse de nuevo.</li>
  </ol>

  <!-- VII -->
  <h2 class="policy-section-title">VII. Contáctenos</h2>
  <p>Si tiene alguna pregunta, póngase en contacto con nuestro equipo de servicio al cliente profesional.</p>
  <ul class="policy-list policy-contact-list">
    <li><strong>Teléfono:</strong> 5594888202</li>
    <li><strong>Correo electrónico:</strong> <a href="mailto:service@cashmoretech.com">service@cashmoretech.com</a></li>
    <li><strong>Horario de atención:</strong> Lunes a viernes, de 9:30 a 18:30 horas</li>
    <li><strong>Dirección:</strong> Eucaliptos No. 504 Letra D Reforma Oaxaca, OAXACA, 68050 México</li>
  </ul>

</div>

  <div class="footbox">
    <div class="footboxcard">
      <div class="footboxcarditem">
        <img src="../assets/address.png" alt="">
        Dirección: Lago Zurich 219, Piso 12, Colonia Ampliación Granada, <br> Miguel Hidalgo, Ciudad de México, C.P. 11529
      </div>
      <div class="footboxcarditem">
        <img src="../assets/email.png" alt="">
       Correo electrónico: support@creditosinfronteras.com
      </div>
    </div>
    <div class="footcopy">
      © Crédito Sin Fronteras, S.A.P.I. de C.V., SOFOM, E.N.R.
    </div>
  </div>
    <!-- <div class="reelbuzz-footer">
      <div class="footer-content">
        <div class="footer-company">    
          <p class="company-title">Te Acreditamos</p>
          <p class="company-name">Simplifique las finanzas y ayúdelo a alcanzar la libertad financiera.</p>
        </div>
        <div class="footer-menu">
         
        </div>
        <div class="footer-contact">
          <div class="contact-title">
            Contáctenos
          </div>
          <div class="contact-name-box">
           <p>Correo electrónico: support@teacreditamosmx.com</p>
         
           <p>Horario de atención: Lunes a viernes de 10:00 a 18:30 horas</p>
           <p>Dirección: Av. Ricardo margain zozaya, 440 piso 8 int 803, Valle del campestre, San Pedro Garza García, Nuevo León, C.P. 66265</p> 
          </div>
        </div>  
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "Home",
  data() {
    return {
      type: 1,
      sections: [
        { id: 'home', title: 'Inicio' },
        { id: 'policy', title: 'Política de privacidad' },
        { id: 'terms', title: 'Términos y Condiciones' },
      ],
      currentSection: ''
    };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  methods: {
    gotoAPP(){
      window.open('https://apps.apple.com/mx/app/id6737598795')
    },
    scrollToSection(id) {
      this.currentSection = id;
      const targetSection = document.getElementById(id);
      if (targetSection) {
        targetSection.scrollIntoView({ behavior: 'smooth' });
      }
    },
    handleScroll() {
      const scrollPosition = window.scrollY;
      this.sections.forEach(section => {
        const targetSection = document.getElementById(section.id);
        if (targetSection.offsetTop <= scrollPosition && targetSection.offsetTop + targetSection.offsetHeight > scrollPosition) {
          this.currentSection = section.id;
        }
      });
    },
    gotoMEnu(id) {
      if(id=='policy'){
        this.$router.push({ name:'policy' })
        return
      }
      if(id=='home'){
        this.$router.push({ name:'Home' })
        return
      }
      if(id=='terms'){
        this.$router.push({ name:'terms' })
        return
      }
      const targetElement = document.getElementById(id);
        if (targetElement) {
          const targetPosition = targetElement.offsetTop + 50;
          const startPosition = window.pageYOffset;
          const distance = targetPosition - startPosition;
          const duration = 500; // 滚动持续时间，单位毫秒
          let startTime = null;

          function animation(currentTime) {
            if (startTime === null) {
              startTime = currentTime;
            }
            const timeElapsed = currentTime - startTime;
            const run = ease(timeElapsed, startPosition, distance, duration);
            window.scrollTo(0, run);
            if (timeElapsed < duration) {
              requestAnimationFrame(animation);
            }
          }

          function ease(t, b, c, d) {
            t /= d / 2;
            if (t < 1) return c / 2 * t * t + b;
            t--;
            return -c / 2 * (t * (t - 2) - 1) + b;
          }

          requestAnimationFrame(animation);
        }
    },
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  }
};
</script>

<style lang="less" scoped>
.policy-box {
  width: 80%;
  margin-left: 10%;
  border-radius: 20px;
  padding: 60px 60px 80px;
  box-sizing: border-box;
  background: #fff;
  font-size: 18px;
  color: #333;
  line-height: 1.8;
  margin-top: -100px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  margin-bottom: 100px;
  .policy-title {
    font-size: 36px;
    font-weight: bold;
    color: #101010;
    margin-bottom: 28px;
    padding-bottom: 16px;
    border-bottom: 3px solid #DDF247;
  }

  .policy-intro {
    color: #555;
    margin-bottom: 16px;
    font-size: 18px;
  }

  .policy-section-title {
    font-size: 22px;
    font-weight: bold;
    color: #101010;
    margin-top: 40px;
    margin-bottom: 16px;
    padding-left: 14px;
    border-left: 4px solid #DDF247;
  }

  .policy-sub-title {
    font-size: 18px;
    font-weight: bold;
    color: #222;
    margin-top: 20px;
    margin-bottom: 8px;
  }

  p {
    margin-bottom: 12px;
  }

  a {
    color: #9e6ffc;
    word-break: break-all;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }

  .policy-list {
    padding-left: 24px;
    margin-bottom: 12px;
    li {
      margin-bottom: 8px;
    }
    &--sub {
      margin-top: 8px;
      list-style: disc;
    }
  }

  .policy-contact-list {
    list-style: none;
    padding-left: 0;
    li {
      padding: 6px 0;
      border-bottom: 1px solid #f0f0f0;
      &:last-child { border-bottom: none; }
    }
  }
}
.policy-box:hover {
  transform: translateY(-20px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15);
}
.color-fff {
  color:#fff;
}
.color-000 {
  color:#000;
}
.color-595 {
  color:#595566 ;
}
.header {
    position: fixed;
    width: 100%;
    z-index: 999;
    background: none;
    transition: 0.5s;
    height: 100px;
    background: #101010;
    color: #fff;

    .header-menu {
        width: 100%;
        max-width: 1800px;
        height: 100px;
        margin: 0 auto;
        padding: 0 40px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .header-left {
            height: 100px;
            width: auto;
            flex: 0 1 auto;
            display: flex;
            align-items: center;
            margin-right: 24px;

            img {
                width: 40px;
                height: 40px;
                margin-right: 20px;
            }

            p {
                font-family: Scada, Scada;
                font-weight: bold;
                font-size: 22px;
                color: #fff;
                line-height: 38px;
            }
        }

        .header-right {
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            list-style: none;
            margin: 0;
            padding: 0;
            flex: 1;
            background: #101010;
            box-sizing: border-box;
            color: #fff;

            .menu {
                margin: 0 10px;
                font-weight: 400;
                font-size: 16px;
                text-align: center;
                cursor: pointer;
                box-sizing: border-box;

                a {
                  color: #fff;
                  padding: 8px 10px;
                }

                .active {
                  color: #000;
                  cursor: pointer;
                }
            }

            .menu:last-child {
                margin-right: 0;
            }

            .active {
                font-weight: 900;
                color: #000;
                border-radius: 20px;
                background: #DDF247;
                transition: all 0.8s;
            }
            .active a {
              color: #000;
            }
        }
    }
}
.reelbuzz-content {
  padding-top: 100px;

  .reelbuzz-box {
    width: 100%;
    height: 800px;
    background: url(../assets/bannel.png) center top no-repeat;
    background-size: 100% 100%;
    overflow: hidden;
    box-sizing: border-box;
    text-align: left;
    font-style: normal;
    text-transform: none;
    .header-box {
      width: 1220px;
      height: 100%;
      margin: 0 auto;
      padding-top: 195px;
      box-sizing: border-box;
      padding-right: 500px;
      .name {
        font-weight: bold;
        font-size: 50px;
        color: #fff;
        line-height: 70px;
        margin-bottom: 32px;
      }
      .title {
        font-family: Roboto, Roboto;
        font-size: 20px;
        color: #FFFFFF;
        line-height: 26px;
      }
    }
  }
}

.audit-box {
  width: 100%;
  height: 480px;

  .audit {
    width: 1320px;
    height: 100%;
    margin: 0 auto;
    box-sizing: border-box;

    .education-box {
      width: 100%;
      height: 460px;
      margin-top: -98px;
      margin-bottom: 140px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .education {
        width: 420px;
        height: 100%;
        background: #fff ;
        box-shadow: 0px 12px 24px 0px rgba(0,0,0,0.08);
        padding: 50px 40px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;

        .img-box {
          width: 100%;
          height: 80px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 30px;
          
          img {
            width: 80px;
            height: 80px;
            
          }

          .img-number {
            font-family: Kavivanar, Kavivanar;
            font-weight: 400;
            font-size: 80px;
            color: #E8E8E8;
            line-height: 118px;
          }
        }
        

        .education-name {
          width: 100%;
          padding-top: 34px;
          box-sizing: border-box;
          border-top: 1px solid #E8E8E8;
          font-weight: bold;
          font-size: 24px;
          color: #333333;
          line-height: 28px;
          margin-bottom: 16px;
        }
        .education-title {
          width: 100%;
          font-weight: 400;
          font-size: 18px;
          color: #999999;
          line-height: 30px;
        }
      }

      .education:hover {
        background:#4850D5;

        .education-name {
          color: #fff;
        }

        .education-title {
          color: rgba(255,255,255,0.8);
        }
      }
    }

  }
}


.choose-us-box {
  height: 740px;
  width: 100%;
  margin-bottom: 120px;
  .choose-us {
    width: 1320px;
    height: 100%;
    padding-top: 120px;
    box-sizing: border-box;
    box-sizing:border-box ;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .choose-us-left {
      width: 704px;
      height: 620px;
      margin-left: -58px;
      transition: all 0.8s;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .choose-us-left:hover {
      transform: rotateX(20deg);
    }

    .choose-us-right {
      width: 600px;
      height: 100%;
      padding-top: 26px;
      box-sizing: border-box;

      .choose-us-name {
        font-weight: bold;
        font-size: 54px;
        color: #333333;
        line-height: 64px;
        margin-bottom: 20px;
      }
      
      .choose-us-title {
        font-weight: 400;
        font-size: 18px;
        color: #999999;
        line-height: 30px;
        margin-bottom: 90px;
      }
      .choose {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 120px;
        width: 598px;
        margin-bottom: 42px;
        
        .choose-box {
          width: 267px;
          height: 120px;

          .choose-img-box{
            width: 267px;
            height: 30px;
            display: flex;
            margin-bottom: 18px;

            img {
              width: 30px;
              height: 30px;
              margin-right: 14px;
            }

            .choose-img-title {
              font-weight: bold;
              font-size: 20px;
              color: #333333;
              line-height: 30px;
            }
          }

          .choose-name {
            font-weight: 400;
            font-size: 18px;
            color: #999999;
            line-height: 30px;
          }
        }
      }
    }
  }
}
.nuestros-box{
   width: 100%;
    height: 1100px;
  // background: url(../assets/card1.png) center center no-repeat;
  background-size: 100% 100%;
  overflow: hidden;
  box-sizing: border-box;
  padding:300px 800px 300px 200px;
  font-size: 18px;
  .nuestros-boxmax{
    font-size: 48px;
    font-weight: bold;
    margin-bottom: 50px;
  }
  .nuestros-box-itemleftheader{
    display: flex;
    justify-content: left;
    margin-bottom: 40px;
    .nuestros-box-itemleftheaderleft{
      img{
       
       
        width: 140px;
        margin-right: 40px;
      }
    }
    .nuestros-box-itemleftheaderright{
      font-size: 30px;
      font-weight: bold;
      margin-bottom: 30px;
      img{
        margin-top: 30px;
        width: 200px;
        cursor: pointer;
      }
    }
  }
}

.services-box {
  width: 100%;
  height: 758px;
  // background: url(../assets/serviceBg.png) center center no-repeat;
  background-size: 100% 100%;
  overflow: hidden;
  box-sizing: border-box;

  .services {
    height: 100%;
    width: 1320px;
    margin: 0 auto;
    box-sizing: border-box;

    .services-block {
      width: 100%;
      height: 150px;
    }
    
    .service-title {
      font-weight: bold;
      font-size: 54px;
      color: #333333;
      line-height: 63px;
      text-align: center;
      margin-bottom: 76px;
    }

    .item-service-box {
      width: 100%;
      height: 280px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .item-service {
        width: 314px;
        height: 280px;
        padding: 50px 30px;
        box-sizing: border-box;
        background: #FFFFFF;
        box-shadow: 0px 12px 24px 0px rgba(0,0,0,0.08);
        border-radius: 20px;
        transition: all 0.8s;

        img {
          width: 86px;
          height: 80px;
          margin-bottom: 20px;
        }
        .item-service-title {
          font-weight: bold;
          font-size: 22px;
          color: #333333;
          line-height: 36px;
          text-align: left;
        }
      }

      .item-service:hover {
        transform: translateY(-30px);
      }
    }
  }
}

.contact-box {
  width: 100%;
  height: 905px;

  .contact {
    width: 1320px;
    height: 100%;
    margin: 0 auto;
    padding-top: 150px;
    box-sizing: border-box;

    .contact-title {
      width: 100%;
      font-weight: bold;
      font-size: 54px;
      color: #333333;
      line-height: 63px;
      text-align: center;
      margin-bottom: 72px;
    }

    .contact-content {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      overflow: hidden;

      .offer-box {
        width: 414px;
        height: 100%;

        .offer-img {
          width: 414px;
          height: 270px;
          overflow: hidden;
          margin-bottom: 35px;

          img {
            width: 414px;
            height: 270px;
            transition: all 0.8s;
          }

          img:hover {
            transform: scale(1.2);
          }
        }

        .offer-title {
          font-weight: bold;
          font-size: 24px;
          color: #333333;
          line-height: 28px;
          text-align: left;
          margin-bottom: 20px;
        }

        .offer-name {
          font-weight: 400;
          font-size: 18px;
          color: #999999;
          line-height: 30px;
        }
      }
    }
  }
}

.reelbuzz-footer {
        width: 100%;
        overflow: hidden;
        box-sizing: border-box;
        background: #191A20;

        .footer-content {
            width: 1240px;
            height: 360px;
            margin: 0 auto;
            display: flex;;

            .footer-company {
                width: 570px;
                height: 100%;
                padding-top: 108px;
                box-sizing: border-box;

              .company-title {
                font-weight: 900;
                font-size: 20px;
                color: #FFFFFF;
                line-height: 24px;
                margin-bottom: 23px;
              }

              .company-name {
                font-weight: 400;
                font-size: 14px;
                color: #FFFFFF;
                line-height: 28px;
              }
            }

            .footer-menu {
                width: 256px;
                height:100%;
                padding-top: 97px;
                box-sizing: border-box;

                .menu-title {
                  font-weight: 900;
                  font-size: 20px;
                  color: #FFFFFF;
                  line-height: 24px;
                  margin-bottom: 24px;
                }

                .menu-name {
                  font-weight: 400;
                  font-size: 14px;
                  color: #FFFFFF;
                  line-height: 28px;
                  cursor: pointer;
                }
            }

            .footer-contact {
              width: 410px;
              height: 100%;
              padding-top: 97px;
              box-sizing: border-box;

              .contact-title {
                font-weight: 900;
                font-size: 20px;
                color: #FFFFFF;
                line-height: 24px;
                margin-bottom: 18px;
              }

              .contact-name-box {
                width: 410px;
                min-height:132px ;
                background: rgba(255,255,255,0.1);
                border-radius: 12px;
                padding: 10px 12px;
                box-sizing: border-box;
                font-weight: 400;
                font-size: 14px;
                color: #FFFFFF;
                line-height: 28px;
              }
            }
        }


    }
    .footbox{
  width: 100%;

  background: #000;
  border-radius: 50px 50px 0px 0px;
  padding-top: 30px;
  padding-bottom: 30px;
  color: #fff;
  font-size: 16px;
  .footboxcard{
    width: 70%;
    margin-left: 15%;
    display: flex;
    justify-content: space-between;

    color: #fff;
    .footboxcarditem{
      img{
        vertical-align: middle;
      }
    }
  }
  .footcopy{
    margin-top: 50px;
    text-align: center;
  }
}
</style>
